import axios, {AxiosError, AxiosResponse} from 'axios';
import {
  ApiResponse,
  CreateBookingRequest,
  ProblemDetails,
  CancelBookingRequest,
  CreateCustomBookingRequest,
  RebookBookingRequestDto,
} from '../lib/interfaces';
import {API_URL} from '../utils/constants';

axios.interceptors.request.use((config) => {
  config.withCredentials = true;
  return config;
});

export async function getWeddingOccasionsApi(): Promise<ApiResponse> {
  try {
    const response = await axios.get(`${API_URL}/weddingOccasions`);
    return apiResponse(response);
  } catch (err) {
    return apiResponseError(err);
  }
}

export async function getFirstAvailableApi(date: string): Promise<ApiResponse> {
  try {
    const response = await axios.get(`${API_URL}/weddingOccasions/FirstAvailable/${date}`);
    return apiResponse(response);
  } catch (err) {
    return apiResponseError(err);
  }
}

export async function createBookingWeddingOccasionApi(bookingRequest: CreateBookingRequest): Promise<ApiResponse> {
  try {
    const res = await axios.post(`${API_URL}/weddingOccasions`, bookingRequest);
    return apiResponse(res);
  } catch (err) {
    return apiResponseError(err);
  }
}

export async function createCustomBookingWeddingOccasionApi(
  customBookingRequest: CreateCustomBookingRequest
): Promise<ApiResponse> {
  try {
    const res = await axios.post(`${API_URL}/WeddingOccasions/Custom`, customBookingRequest);
    return apiResponse(res);
  } catch (err) {
    return apiResponseError(err);
  }
}

export async function rebookBookingApi(body: RebookBookingRequestDto): Promise<ApiResponse> {
  try {
    const response = await axios.put(`${API_URL}/Bookings/Rebook`, body);
    return apiResponse(response);
  } catch (err) {
    return apiResponseError(err);
  }
}

export async function getMyBookingsApi(personalIdentityNumber: string): Promise<ApiResponse> {
  try {
    const res = await axios.post(`${API_URL}/Bookings/GetByPerson`, {personalIdentityNumber});
    return apiResponse(res);
  } catch (err) {
    return apiResponseError(err);
  }
}

export async function cancelBookingApi(body: CancelBookingRequest): Promise<ApiResponse> {
  try {
    const response = await axios.post(`${API_URL}/Bookings/Cancel`, body);
    return apiResponse(response);
  } catch (err) {
    return apiResponseError(err);
  }
}

export async function getWeddingOfficiantsApi(): Promise<ApiResponse> {
  try {
    const response = await axios.get(`${API_URL}/weddingOfficiants`);
    return {status: response.status, data: response.data};
  } catch (err) {
    console.log('An error ocurred: ', err);
    return {message: 'error', type: ''} as ApiResponse;
  }
}

function apiResponse(response: AxiosResponse<any, any>): ApiResponse {
  return {status: response.status, data: response.data} as ApiResponse;
}

function apiResponseError(err: any) {
  const e = err as AxiosError<ProblemDetails, any>;
  console.log('An error ocurred: ', err);
  return {
    message: e.response?.data?.detail ?? e.response?.data,
    type: e.name,
    status: e.response?.status ?? 555,
  } as ApiResponse;
}
